import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { loginRequestScopes } from '@/lib/auth/msal-config';
import { useMe } from './useMe';

/**
 * Gate de autenticação. Sem login: botão de SSO Entra. Com login: busca o GET /api/me
 * e mostra a identidade do usuário (nome/e-mail/papel). É o primeiro fluxo ponta a ponta
 * frontend → backend do Pipeline Vega.
 */
export function AuthGate() {
  const isAuthenticated = useIsAuthenticated();
  const { instance } = useMsal();
  const me = useMe(isAuthenticated);

  if (!isAuthenticated) {
    return (
      <button
        type="button"
        className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground"
        onClick={() => {
          void instance.loginRedirect({ scopes: loginRequestScopes });
        }}
      >
        Entrar com conta Vega
      </button>
    );
  }

  if (me.isLoading) {
    return <p className="text-sm text-muted-foreground">Carregando seu perfil…</p>;
  }

  if (me.isError || !me.data) {
    return <p className="text-sm text-destructive">Não foi possível carregar seu perfil.</p>;
  }

  const user = me.data;
  return (
    <div className="space-y-1">
      <p className="text-sm">
        Olá, <span className="font-medium">{user.name}</span>
      </p>
      <p className="text-xs text-muted-foreground">{user.email}</p>
      <p className="text-xs text-muted-foreground">
        Papel: {user.role}
        {user.isAdmin ? ' (admin)' : ''}
      </p>
    </div>
  );
}
